// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__MsE7Z","wrapper":"Navigation_wrapper__vKHUi","right-nav-group":"Navigation_right-nav-group__fHxA+","burger-icon":"Navigation_burger-icon__UK4wX"};